
import { Endpoints } from "@/api/ApiEndpoints";
import { formatDate } from "@/core/helpers/DatetimeConverter";

const COUPON_STATUSES = {
	0: { text: 'Open', className: 'status-open' },
	1: { text: 'Won', className: 'status-won' },
	2: { text: 'Lost', className: 'status-lost' },
};

const statusBadge = (item) => {
	const status = COUPON_STATUSES[item.statusId ?? 0] ?? COUPON_STATUSES[0];
	return "<span class='coupon-status " + status.className + "'>" + status.text + "</span>";
};

const CouponsMap = {
	Plural: 'Coupons',
	Single: 'Coupon',
	ModalForm: false,
	DefaultSorting: 'ID',
	DefaultSortingType: 'desc',
	ShowInnerRows: true,
	Columns: [

		{
			name: 'header',
			dbName: 'header',
			label: 'Header',

			type: 'text',
			format: (item) => {
				return "<div class='box-header'><div class='user'>#" + item.id + "<br> <a href='/users/list?pageNumber=1&SearchTerm="+item.user.nickName+"'>" + item.user.nickName + "</a></div><div class='couponDate'>" + formatDate(item.createdAt) + statusBadge(item) + "</div></div>";
			}

		},

	],
	Footer: [
		{
			name: 'coins',
			dbName: 'Coins',
			label: 'Coins',
			sortable: true,
			required: true,
			type: 'text',
			format: (item) => {
				return '<div class="coins"><img src="/media/icons/duotune/finance/fin008.svg"/>' + item.coins + '</div>';
			}
		},
		{
			name: 'totalOdd',
			dbName: 'totalOdd',
			label: 'Total Odd',
			type: 'text',
			format: (item) => {
				return '<div class="bet-game-odd">' + item.totalOdd + '</div>';
			}


		},

	],
	FooterButtons: [

		// 👉 New action button
		{
			name: 'actions',
			label: '',
			type: 'button',              // <-- tell BoxWidget to render a real <button>
			text: 'Validate Coupon',            // <-- button label
			onClick: 'callCouponApi',    // <-- handler name (implemented in BoxWidget)
			variant: 'primary',          // <-- optional, to pick a bootstrap class
			// showIf: (coupon) => {
			// 	// handle either numeric or text status fields
			// 	const s = coupon.statusId ?? coupon.status;
			// 	return s === 0 || s === 'Open';
			// },
			api: {
				method: "GET",                    // "GET" | "POST" | "PATCH" | "DELETE"
				// string or (row) => string
				endpoint: (row) => `${Endpoints.COUPON_VALIDATE}/${row.id}`,
				// optional: query params for GET/DELETE or body for POST/PATCH
				// object or (row, ctx) => object
				params: (row) => ({ force: true }),
				// for POST/PATCH if needed:
				// body: (row) => ({ ... })
				// after call:
				refreshList: true,                // re-fetch current page
				successMessage: "Coupon validated",
			},
		},
		{
			name: 'clearTournament',
			label: '',
			type: 'button',
			text: 'Clear Tournament',
			onClick: 'callCouponApi',
			variant: 'warning',
			showIf: (coupon: any) => {
				const s = coupon.statusId ?? coupon.status;
				return (s === 0 || s === 'Open') && coupon.tournamentId != null;
			},
			api: {
				method: "POST",
				endpoint: (row: any) => `${Endpoints.COUPON_CLEAR_TOURNAMENT}/${row.id}`,
				refreshList: true,
				successMessage: "Tournament cleared",
			},
		},
	],
	InnerColumn: {
		key: "bets", // field inside each item that holds the nested data
		columns: [
			{

				name: 'Game',
				label: 'Game',
				required: true,
				type: 'text',
				format: (item) => {
					let oddText = "";
					if(item.marketId ==1){
						if (item.oddLabel == 1) {
						oddText = item.homeTeam.name;
					}
						else if (item.oddLabel == 2) {
							oddText = item.awayTeam.name;
						}
						else if (item.oddLabel == "X") {
							oddText = 'Draw';
						}
					}										
					
					else {
						if(item.marketName == 'Goal Line' || item.marketName == 'Double Chance'  || item.marketName == 'Exact Goal'){
							oddText = item.oddLabel;
							if (item.marketDescription != null) {
								oddText += " " + item.marketDescription;
							}
						}
						else{
							oddText = item.marketName;
							if (item.marketDescription != null) {
								oddText += " " + item.marketDescription;
							}
							oddText +=  " "+ item.oddLabel;
						}
						
					}
					
					let htmlToReturn = '<div class="bet-game">';
					htmlToReturn += '<div class="bet-game-header">'
					htmlToReturn += '<div class="bet-game-title">'
					htmlToReturn += oddText;
					htmlToReturn += '</div>'
					htmlToReturn += '</div>'
					htmlToReturn += '<div class="bet-game-odd">' + item.oddValue + '</div>';
					htmlToReturn += '</div>';
					htmlToReturn += '<a class="bet-game-game" style="color:#fff" href="/games/edit/' + item.gameProviderID + '">' + item.homeTeam.name + ' - ' + item.awayTeam.name + '</div>';
					htmlToReturn += '<div>' + formatDate(item.gameDate) + '</div>';

					return htmlToReturn;
				}
			},


		],
	},
	InitialFilters:
	{

		Status: {
			value: "Open",
			valueText: "Open",
			clear: null,
			type: "object",
		},

	},
	Filters: [
		{
			name: 'Status',
			label: 'Status',
			nameToRequest: 'status',
			type: 'radioButtonWithStaticValues',
			attributes: {
				type: 'staticValue',
				values: ['Open', 'Won', 'Lost'],
			},
		},
	],
	PrimaryKey: 'id',
	Actions: {
		editLink: '/coupons/edit/',

	},
};

export default CouponsMap;
